module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_SaveAs_16"],"path":[{"$":{"d":"M7,8h8V4L12,1H1V15H7V13H3V8ZM4,2H9V5h2V2h1V6H4ZM16,12l-4,4L8,12h3V9h2v3Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_SaveAs_16.svg
// module id = KA8d
// module chunks = 1